export const langList = [
	{ label: 'Choose Language', value: '' },
	{ label: 'English', value: 'en' },
	{ label: 'French', value: 'fr' },
	{ label: 'German', value: 'de' },
	{ label: 'Italian', value: 'it' },
	{ label: 'Spanish', value: 'es' },
	{ label: 'Portuguese', value: 'pt' },
	{ label: 'Croatian', value: 'hr' },
	{ label: 'Swedish', value: 'sv' },
];
